import { isURL } from 'validator';

export default function isValidURL(suspect) {
  if (!suspect) {
    return false;
  }
  return isURL(suspect, { protocols: ['http', 'https'] });
}
